// extracted by mini-css-extract-plugin
module.exports = {"navToggle":"nav-toggle_navToggle__q7kTt","navToggleOpen":"nav-toggle_navToggleOpen__rCvsN","navText":"nav-toggle_navText__A0O5d"};